import { useCallback, useEffect, useState } from 'react';
import { BalanceCreditApplicationUrlApiResponse } from 'src/types/Balance';
import { fetchBalanceCreditApplicationUrl as fetchBalanceCreditApplicationUrlFromApi } from 'src/components/selfService/common/Balance/api/fetchBalanceCreditApplicationUrl';

export type UseFetchBalanceCreditApplicationUrlReturnType = {
  isLoading: boolean;
  hasError: boolean;
  balanceCreditApplicationUrl: BalanceCreditApplicationUrlApiResponse | null;
  fetchBalanceCreditApplicationUrl: () => Promise<void>;
};

export const useFetchBalanceCreditApplicationUrl = (
  onboardingId: string | null,
  corpId: string | null
): UseFetchBalanceCreditApplicationUrlReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [balanceCreditApplicationUrl, setBalanceCreditApplicationUrl] =
    useState<BalanceCreditApplicationUrlApiResponse | null>(null);

  const fetchBalanceCreditApplicationUrl =
    useCallback(async (): Promise<void> => {
      if (!onboardingId || !corpId) {
        return;
      }

      try {
        setIsLoading(true);
        setHasError(false);

        const response = await fetchBalanceCreditApplicationUrlFromApi(
          onboardingId,
          corpId
        );
        setBalanceCreditApplicationUrl(response);
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    }, [onboardingId, corpId]);

  useEffect(() => {
    fetchBalanceCreditApplicationUrl();
  }, [onboardingId, corpId, fetchBalanceCreditApplicationUrl]);

  return {
    isLoading,
    hasError,
    balanceCreditApplicationUrl,
    fetchBalanceCreditApplicationUrl,
  };
};
